export const deleteSession = () => {
    localStorage.clear();
    sessionStorage.clear();
};
